import Vue from "vue";
import VueFloatLabel from "vue-float-label";

Vue.use(VueFloatLabel);
